import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";

import CheckoutProgressHero from "../checkout-progress-hero";
import PrimaryButton from "../../elements/primary-button";
import BodyText from "../../elements/body-text";
import Input from "../../elements/input";
import { isBizNull } from "../../utils";
import api from "../../utils/api";
import { isValidEmail } from "../../utils/validations";
import { printPdf } from "../../utils/lynkco-constants";
import { getOrderType, getGearOrderType, gearOrderDetails } from "../../utils/processesOrderDetails";
import { clearCartItemsFromStorage, setSessionIdAction } from "../../redux/actions/actions";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction } from "../../redux/actions/gears-checkout";
import { selectCartItemsState, selectSessionId, selectUserState } from "../../selectors/application";
import { contactInfoSelector, isMemberSelector } from "../../selectors/gears-checkout";
const InStoreConfirmation = ({ fields, lang, user, clearBillingInfo, clearShippingInfo, clearContactInfo, hero, orderId, isMember, accountInfo }) => {
  const { orderFields, storeInfo } = fields;
  const {
    emailInputErrorMessage,
    emailInputMissingMessage,
    emailInputLabel,
    guestBody,
    guestNoLoginEmailBody,
    guestDigitalTitle,
    guestSendButton,
    guestReceiptBody,
    guestReceiptButton,
    guestReceiptHeadingBody,
    guestheadingBody,
    memberBody,
    memberNoLoginEmailBody,
    memberDigitalTitle,
    memberReceiptBody,
    memberReceiptButton,
    memberReceiptHeadingBody,
    memberheadingBody,
    apiSuccess,
    apiError
  } = storeInfo?.fields;
  // const billingInfoRef = useRef(null);
  const pdfIframeRef = useRef(null);
  const isLoggedIn = !isMember,
    // const isLoggedIn = false,
    [orderDetail, setOrderDetail] = useState(null),
    [payUrl, setPayUrl] = useState(null),
    [apiRes, setApiRes] = useState(null),
    [orderType, setOrderType] = useState(""),
    emailFormProp = {
      email: {
        label: emailInputLabel?.value,
        warningMessage: emailInputErrorMessage?.value
      },
      submitButton: {
        colorScheme: "dark",
        buttonText: guestSendButton?.fields?.link?.value?.text,
        icon: guestSendButton?.fields?.iconName?.value?.alt,
        callback: function(e) {
          e.preventDefault();
          alert("Continue pressed!");
        }
      }
    };
  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    clearBillingInfo();
    clearShippingInfo();
    clearContactInfo();
    const { orderDetail } = await gearOrderDetails({
      orderId: orderId,
      orderFields: orderFields,
      lang: lang,
      inStore: true
    });
    let _orderType = getOrderType(orderDetail?.subType);
    let printOrderType = getOrderType(orderDetail?.subType);
    if (_orderType === "gears") {
      _orderType = getGearOrderType(orderDetail?.deliveryMethod);
      printOrderType = printPdf.gearConfirm;
    }
    setOrderType(_orderType);
    setOrderDetail(orderDetail);
    setPayUrl(`/${lang}/PdfView?type=${printOrderType}&pageFormat=A5&orderNo=${orderDetail?.orderNo}`);
  };
  let heading = guestheadingBody?.value,
    printPdfState = true,
    digitalReceipt = {
      heading: guestDigitalTitle?.value,
      body: isLoggedIn ? guestNoLoginEmailBody.value : `${guestBody?.value}<span style="color: #1ef1c6;">${orderDetail?.billingInfo?.email || user?.email || ""}</span>`
    },
    printedReceipt = {
      heading: guestReceiptHeadingBody?.value,
      body: guestReceiptBody?.value,
      button: {
        buttonText: guestReceiptButton?.fields?.buttonText?.value,
        iconName: guestReceiptButton?.fields?.iconName,
        colorScheme: guestReceiptButton?.fields?.colorScheme,
        callback: function(e) {
          e.preventDefault();
          printingButtonCallBack();
          alert("Print button pressed! Printing is handled from this callback.");
        }
      }
    };
  if (orderType === printPdf.gearsSale) {
    heading = memberheadingBody?.value;
    digitalReceipt = {
      heading: memberDigitalTitle?.value,
      body: isLoggedIn ? memberNoLoginEmailBody.value : `${memberBody?.value}<span style="color: #1ef1c6;">${orderDetail?.billingInfo?.email || user?.email || ""}</span>`
    };
    printedReceipt = {
      heading: memberReceiptHeadingBody?.value,
      body: memberReceiptBody?.value,
      button: {
        buttonText: memberReceiptButton?.fields?.buttonText?.value,
        iconName: memberReceiptButton?.fields?.iconName,
        colorScheme: memberReceiptButton?.fields?.colorScheme,
        callback: function(e) {
          e.preventDefault();
          printingButtonCallBack();
          // alert(
          //   "Print button pressed! Printing is handled from this callback."
          // );
        }
      }
    };
  }
  const sendButtonCallBack = (evt, formData) => {
      api.order
        .backup(null, {
          orderNo: orderDetail?.orderNo,
          eventType: "ORDEREVENTTYPE03",
          receiver: formData?.email,
          staff: accountInfo.account.userName
        })
        .then(res => {
          setApiRes(apiSuccess?.value);
        })
        .catch(err => {
          setApiRes(apiError?.value);
        });
    },
    setEmailFocus = () => {
      setApiRes(null);
    },
    printingButtonCallBack = () => {
      // setPayUrl(`/${lang}/PdfView?type=presale&pageFormat=A5&orderNo=8B8B57003C21000`);
      pdfIframeRef.current.contentWindow.print();
    };
  const digitalReceiptClasses = classNames("receipt-digital", {
    "extra-margin": isLoggedIn
  });
  return (
    <div className="in-store-confirmation">
      <CheckoutProgressHero {...hero} />
      <div className="grid">
        <div className="heading-top">
          <h3 className="type-h3 show-on-scroll">{heading}</h3>
        </div>
        <div className={digitalReceiptClasses}>
          <h3 className="type-h3">{digitalReceipt.heading}</h3>
          <BodyText html={digitalReceipt.body} />
          <React.Fragment>
            {isLoggedIn && (
              <EmailForm
                {...{
                  emailInputLabel,
                  emailInputErrorMessage,
                  emailInputMissingMessage,
                  // submitLogin,
                  guestSendButton,
                  apiRes,
                  sendButtonCallBack,
                  setEmailFocus
                }}
                {...emailFormProp}
              />
            )}
          </React.Fragment>
        </div>
        <div className="receipt-printed">
          <h3 className="type-h3">{printedReceipt.heading}</h3>
          <BodyText html={printedReceipt.body} />
          {printPdfState && <PrimaryButton {...printedReceipt.button} />}
        </div>
      </div>
      <iframe ref={pdfIframeRef} style={{ display: "none" }} src={payUrl} />
    </div>
  );
};
const EmailForm = ({ apiRes, setEmailFocus, emailInputLabel, emailInputErrorMessage, emailInputMissingMessage, guestSendButton, sendButtonCallBack, printingButtonCallBack }) => {
  const [formDataEmail, setEmail] = useState();
  const [emailError, setEmailError] = useState(null);
  const [apiWarnning, setApiWarnning] = useState(null);
  useEffect(() => {
    setApiWarnning(apiRes);
  }, [apiRes]);
  const onEmailFocus = evt => {
    setEmailError(null);
    setEmailFocus && setEmailFocus();
  };
  const onEmailBlur = (evt, valid) => {
    setEmail(evt.target.value);
    if (valid === false) {
      setEmailError(emailInputErrorMessage.value);
    } else {
      setEmailError(null);
    }
  };
  const onSubmit = evt => {
    const formData = { email: formDataEmail };
    if (validateForm()) {
      sendButtonCallBack(evt, formData);
    }
  };
  const validateForm = () => {
    let result = true;
    if (isBizNull(formDataEmail)) {
      result = false;
      setEmailError(emailInputMissingMessage.value);
    } else if (!isValidEmail(formDataEmail)) {
      result = false;
      setEmailError(emailInputErrorMessage.value);
    } else {
      setEmailError(null);
    }
    return result;
  };
  return (
    <form className="login-form" autoComplete="on">
      {emailInputLabel && (
        <Input
          {...{
            autocomplete: "email",
            name: "email",
            label: emailInputLabel.value,
            warningMessage: emailError,
            type: "email",
            showError: emailError !== null,
            onFocus: evt => onEmailFocus(evt),
            onBlur: (evt, valid) => onEmailBlur(evt, valid)
          }}
        />
      )}
      {apiWarnning && <BodyText html={apiWarnning} />}
      <div className="button-container">
        {guestSendButton?.fields && (
          <PrimaryButton
            {...{
              ...guestSendButton.fields,
              // link: {
              //   value: {
              //     ...guestSendButton?.fields.link?.value,
              //     href: ""
              //   }
              // },
              buttonText: guestSendButton?.fields?.buttonText?.value,
              callback: evt => onSubmit(evt)
            }}
          />
        )}
      </div>
    </form>
  );
};
InStoreConfirmation.propTypes = {
  hero: PropTypes.object,
  heading: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  // emailForm: PropTypes.object,
  digitalReceipt: PropTypes.shape({
    heading: PropTypes.string,
    body: PropTypes.string
  }),
  printReceipt: PropTypes.shape({
    heading: PropTypes.string,
    body: PropTypes.string,
    printButton: PropTypes.object
  })
};

const mapDispatchToProps = dispatch => ({
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  clearCartItemsFromStorage: () => dispatch(clearCartItemsFromStorage()),
  clearBillingInfo: () => dispatch(clearBillingInfoAction()),
  clearShippingInfo: () => dispatch(clearShippingInfoAction()),
  clearContactInfo: () => dispatch(clearContactInfoAction())
});
const mapStateToProps = state => ({
  user: selectUserState(state),
  isMember: isMemberSelector(state),
  contactFormData: contactInfoSelector(state),
  cartItems: selectCartItemsState(state),
  sessionId: selectSessionId(state)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InStoreConfirmation));
